import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-views-common/advanced-filters/date-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export function getCustomFieldDateFilter(
  key: string,
  displayName: string,
): AdvancedTableFilter {
  return {
    type: AdvancedFilterType.DATE,
    Icon: CalendarIcon,
    data: {
      name: key,
      type: AdvancedFilterType.DATE,
      value: null,
      operator: DateFilterOperator.WITHIN,
    },
    displayName,
  };
}
